module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/companies_mountain_2-d32d332db57274278b7cae6cb1af4320.svg";